import Vue from 'vue'
import VueRouter from 'vue-router'

import Landing from '@/pages/Landing'
import Register from '@/pages/Register'
import Wishlist from '@/pages/Wishlist'
import ExampleGuestcard from '@/pages/ExampleGuestcard'
import TermsAndConditions from '@/pages/TermsAndConditions'

Vue.use(VueRouter)
const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Landing-view',
      component: Landing
    },
    {
      path: '/:wishlistType/register',
      name: 'Register-view',
      component: Register
    },
    {
      path: '/event/:wishlistType',
      name: 'Wishlist-view',
      component: Wishlist
    },
    {
      path: '/:wishlistType/example-guestcard',
      name: 'Wishlist-example-guestcard',
      component: ExampleGuestcard
    },
    {
      path: '/:wishlistType/terms-and-conditions',
      name: 'Wishlist-Terms-And-Conditions',
      component: TermsAndConditions
    },
    {
      path: '/faf-login',
      name: 'redirect',
      component: Landing
    }
  ]
})

router.beforeEach(function (to, from, next) {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  next()
})
export default router
